import React from 'react';
import { Card, List, Avatar } from 'antd';
import Title from '../Account/Title';
import DesktopDescription from '../Account/DesktopDescription';
import MobileDescription from '../Account/MobileDescription';
import { PastOrdersState } from '../../common/types';
import UseWindowSize from '../../hooks/UseWindowSize';
const { Meta } = Card;

function PastOrdersItemCard({ item }: PastOrdersState) {
  const { width } = UseWindowSize();
  return (
    <Card>
      <Meta
        avatar={
          <Avatar
            src={item.cover}
            shape="square"
            alt="Food Item"
            style={{ height: 100, width: 250 }}
          />
        }
        title={<Title title={item.resurantName} />}
        description={
          <List itemLayout="horizontal">
            <List.Item>
              <List.Item.Meta
                description={
                  width > 576 ? (
                    <DesktopDescription item={item} />
                  ) : (
                    <MobileDescription item={item} />
                  )
                }
              />
            </List.Item>
          </List>
        }
      />
    </Card>
  );
}

export default PastOrdersItemCard;
